import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import {
  ExamSessionDetails,
  SessionType,
} from '../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const createNewSessionOperations = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  loading: (loading: boolean) => any,
  setExamDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId) {
      toast.warn('לא ניתן לאתר את מזהה הקורס נסה שוב בעוד מספר רגעים...');
      return;
    }
    loading(true);
    const res = await appApi.addNewExamSession(
      programId!,
      courseId,
      examId,
      SessionType.SECOND_SESSION,
    );
    setExamDetails(res.data.body);
    toast.success('המועד נוסף בהצלחה');
    loading(false);
  } catch (e) {
    console.error(`createNewSessionOperations is failed with the error: ${e}`);
    toast.error('לא ניתא לבצע את הפעולה המבוקשת, נסה שוב בעוד מספר רגעים');
    loading(false);
  }
};
